var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7.74142H7C5.89543 7.74142 5 8.63686 5 9.74142V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V9.74142C19 8.63686 18.1046 7.74142 17 7.74142ZM7 6.74142C5.34315 6.74142 4 8.08457 4 9.74142V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V9.74142C20 8.08457 18.6569 6.74142 17 6.74142H7Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19189 7.29223C8.19189 5.59014 9.57171 4.21033 11.2738 4.21033H12.7262C14.4283 4.21033 15.8081 5.59014 15.8081 7.29223H14.8081C14.8081 6.14243 13.876 5.21033 12.7262 5.21033H11.2738C10.124 5.21033 9.19189 6.14243 9.19189 7.29223H8.19189Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12735 12.7659C4.12735 12.4897 4.3512 12.2659 4.62735 12.2659H19.3704C19.6465 12.2659 19.8704 12.4897 19.8704 12.7659C19.8704 13.042 19.6465 13.2659 19.3704 13.2659H12.4877V14.0275C12.4877 14.3037 12.2638 14.5275 11.9877 14.5275C11.7115 14.5275 11.4877 14.3037 11.4877 14.0275V13.2659H4.62735C4.3512 13.2659 4.12735 13.042 4.12735 12.7659Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.2cab1fee016567dd3bb7bae3ad1ee6a0.svg";
export { ForwardRef as ReactComponent };